import { render, staticRenderFns } from "./orderShshenpi.vue?vue&type=template&id=48744caf&scoped=true"
import script from "./orderShshenpi.vue?vue&type=script&lang=js"
export * from "./orderShshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderShshenpi.vue?vue&type=style&index=0&id=48744caf&prod&scoped=true&lang=css"
import style1 from "./orderShshenpi.vue?vue&type=style&index=1&id=48744caf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48744caf",
  null
  
)

export default component.exports